
import SearchComponent from './logic/SearchComponent';
export default SearchComponent;
